import { lazy, mixed, number, object, string } from "yup";

import {
  PriceMoneyResource,
  priceMoneyResourceSchema,
} from "./PriceMoneyResource";

export enum SubscriptionItemType {
  Plan = "plan",
  Addon = "addon",
}

export interface SubscriptionItemPlanProduct {
  planId: number;
  planVariantId: number;
}

export interface SubscriptionItemAddonProduct {
  addonId: number;
  planAddonId: number;
}

type SubscriptionItemProduct =
  SubscriptionItemPlanProduct | SubscriptionItemAddonProduct;

export interface SubscriptionItemResource {
  uuid: string;
  type: SubscriptionItemType;
  name: string;
  quantity: number;
  price: PriceMoneyResource;
  product: SubscriptionItemProduct;
}

const subscriptionItemPlanProductSchema = object({
  planId: number().required(),
  planVariantId: number().required(),
});

const subscriptionItemAddonProductSchema = object({
  addonId: number().required(),
  planAddonId: number().required(),
});

export const subscriptionItemResourceSchema = object({
  uuid: string().required(),
  type: mixed<SubscriptionItemType>()
    .oneOf(Object.values(SubscriptionItemType) as SubscriptionItemType[])
    .required(),
  name: string().required(),
  quantity: number().required(),
  price: priceMoneyResourceSchema.required(),
  product: lazy((_, { parent }) =>
    parent.type === SubscriptionItemType.Plan
      ? subscriptionItemPlanProductSchema
      : subscriptionItemAddonProductSchema,
  ),
});
